/* =================================================================== Homepage Banner Slider === */
/* ==================================================================================== */

require("slick-carousel");

$(document).ready(function (evt) {
  slickFadeSlider();
});

function slickFadeSlider() {
  $(".campaign-banner__slider").slick({
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 500,
    fade: true,
    cssEase: "linear",
    draggable: false,
    arrows: false,
    swipeToSlide: false,
  });
}
